import { NavLink, useParams } from "react-router-dom";

const WaiverTabs = () => {
  const { waiverId } = useParams();

  const tabClass = ({ isActive }) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition ${
      isActive
        ? "bg-black text-white"
        : "text-gray-600 hover:bg-gray-100"
    }`;

  return (
    <div className="bg-white border rounded-xl p-3 mb-6">
      <div className="flex gap-2">
        <NavLink
          to={`/business/waiverviewer/${waiverId}/overview`}
          className={tabClass}
        >
          Overview
        </NavLink>

        <NavLink
          to={`/business/waiverviewer/${waiverId}/eligibility`}
          className={tabClass}
        >
          Eligibility Rules
        </NavLink>

        <NavLink
          to={`/business/waiverviewer/${waiverId}/signer-preview`}
          className={tabClass}
        >
          Signer Preview
        </NavLink>

        <NavLink
          to={`/business/waiverviewer/${waiverId}/content`}
          className={tabClass}
        >
          Waiver Content
        </NavLink>

        <NavLink
          to={`/business/waiverviewer/${waiverId}/version-history`}
          className={tabClass}
        >
          Version History
        </NavLink>
      </div>
    </div>
  );
};

export default WaiverTabs;